<script>
    import SubscriberNavbar from "../components/Navbars/SubscriberNavbar.svelte";
    import RegisterLogin from "../views/formSubscriber/RegisterLogin.svelte";
    import SubscriberForm from "../components/Forms/Subscriber/SubscriberForm.svelte";
    import RegisterHome from "../views/formSubscriber/RegisterHome.svelte";
    import SubscriberPayment from "../views/formSubscriber/SubscriberPayment.svelte";
    import SubscriberPaymentThankYou from "../views/formSubscriber/SubscriberPaymentThankYou.svelte";
    import SubscriberPaymentFailure from "../views/formSubscriber/SubscriberPaymentFailure.svelte";
    import SubscriptionFAQ from "../views/formSubscriber/SubscriptionFAQ.svelte";
    import Policy from "../views/formSubscriber/Policy.svelte";
    import CollectSubscribers from "../components/Forms/Subscriber/CollectSubscribers.svelte";
    import MembershipHome from "../views/formSubscriber/MembershipHome.svelte";
    import { Route, Router } from "svelte-routing";
    import { settings } from "../stores/settingsStore";

    let isBackgroundVisible = false;
</script>

<div class="relative {isBackgroundVisible ? 'mainBG' : ''} h-full overflow-y-auto">
    <SubscriberNavbar />

    <div class="w-full h-full grid min-h-screen pt-32 dropfilter-container p-4 md:px-0">
        <Router url="subscribers">
            <Route path="policy" component={Policy} />
            <Route path="aiuto" component={SubscriptionFAQ} />

            {#if !$settings.disableSubscriptions}
                <Route component={RegisterHome} />
                <Route path="raccolta-adesioni/login" component={RegisterLogin} />
                <Route path="iscriviti-home" component={MembershipHome} />
                <Route path="iscriviti">
                    <div class="flex justify-center">
                        <div class="w-full px-2 md:px-0 md:w-10/12 lg:w-5/12">
                            <SubscriberForm />
                        </div>
                    </div>
                </Route>
                <Route path="rinnovo">
                    <div class="flex justify-center">
                        <div class="w-full px-2 md:px-0 md:w-10/12 lg:w-5/12">
                            <SubscriberForm isRenew={true} />
                        </div>
                    </div>
                </Route>
                <Route path="raccolta-adesioni" component={CollectSubscribers} />
                <Route path="pagamento" component={SubscriberPayment} />
                <Route path="grazie" component={SubscriberPaymentThankYou} />
                <Route path="pagamento-fallito" component={SubscriberPaymentFailure} />
            {:else}
                <Route>
                    <div class="flex justify-center items-center text-3xl si-font font-bold red-si">
                        {$settings.disableSubscriptionsLabel}
                    </div>
                </Route>
            {/if}
        </Router>
    </div>
</div>


<style>
    @media (min-width: 1024px){
        .lg\:w-5\/12{
            width: 41%;
        }
    }
</style>